import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-square-four-lined",
  "use": "rt-portal-square-four-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-portal-square-four-lined\"><path fill=\"#8B9FC6\" d=\"M432 112H152c-22.1 0-40 17.9-40 40v280c0 22.1 17.9 40 40 40h280c22.1 0 40-17.9 40-40V152c0-22.1-17.9-40-40-40z m-20 300H172V172h240v240zM872 112H592c-22.1 0-40 17.9-40 40v280c0 22.1 17.9 40 40 40h280c22.1 0 40-17.9 40-40V152c0-22.1-17.9-40-40-40z m-20 300H612V172h240v240zM432 544H152c-22.1 0-40 17.9-40 40v280c0 22.1 17.9 40 40 40h280c22.1 0 40-17.9 40-40V584c0-22.1-17.9-40-40-40z m-20 300H172V604h240v240zM872 544H592c-22.1 0-40 17.9-40 40v280c0 22.1 17.9 40 40 40h280c22.1 0 40-17.9 40-40V584c0-22.1-17.9-40-40-40z m-20 300H612V604h240v240z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/square-four-lined.svg
// module id = 1889
// module chunks = 137